export const GET_EQUIPMENT_INFO_REQUEST = 'GET_EQUIPMENT_INFO_REQUEST';
export const GET_EQUIPMENT_INFO_SUCCESS = 'GET_EQUIPMENT_INFO_SUCCESS';
export const GET_EQUIPMENT_INFO_FAILURE = 'GET_EQUIPMENT_INFO_FAILURE';

export const SAVE_EQUIPMENT_INFO_REQUEST = 'SAVE_EQUIPMENT_INFO_REQUEST';
export const SAVE_EQUIPMENT_INFO_SUCCESS = 'SAVE_EQUIPMENT_INFO_SUCCESS';
export const SAVE_EQUIPMENT_INFO_FAILURE = 'SAVE_EQUIPMENT_INFO_FAILURE';

export const RESET_SAVE_SUCCESS = 'RESET_SAVE_SUCCESS';

export const CONNECTION_STATUS_REQUEST = 'CONNECTION_STATUS_REQUEST';
export const CONNECTION_STATUS_SUCCESS = 'CONNECTION_STATUS_SUCCESS';
export const CONNECTION_STATUS_FAILURE = 'CONNECTION_STATUS_FAILURE';
